export default __webpack_public_path__ + "static/media/svg-2.27bd255a.svg";